import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';

export default class SmartInsightsUpsellAdapter extends ApplicationAdapter {
  // @ts-expect-error: Property 'buildURL' in type 'SmartInsightsUpsellAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot,
    requestType: string,
    query: Record<string, unknown>,
  ) {
    if (requestType === 'updateRecord') {
      return `${this.host}/${this.namespace}/smartinsights/upsell/?subscription_id=${id}`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 5.
    return super.buildURL(modelName, id, snapshot, requestType, query);
  }

  pathForType(modelName: string): string {
    // Prevent Ember Data from pluralising to /smartinsights/upsells.
    return modelName;
  }
}
